import Vue from 'vue';
import VueMeta from 'vue-meta';
import App from './App.vue';
import router from './router';
import store from './store/store';
import './plugins/element';
import '@/styles/iconfont/iconfont.css';
import '@/styles/index.scss';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'en',
  messages: {
    en: require('./locales/en.js'),
    kr: require('./locales/kr.js'),
  },
});

Vue.use(VueMeta);

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
